var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5292C28.3014 35.5292 35 28.78 35 20.4927C35 12.2055 28.3014 5.45624 20 5.45624C11.6986 5.45624 5 12.2055 5 20.4927C5 28.78 11.6986 35.5292 20 35.5292Z",
    stroke: "#054D94",
    strokeOpacity: 0.2,
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.0475C28.5621 36.0475 35.5 29.0817 35.5 20.4927C35.5 11.9038 28.5621 4.93799 20 4.93799C11.4379 4.93799 4.5 11.9038 4.5 20.4927C4.5 29.0817 11.4379 36.0475 20 36.0475Z",
    fill: "#3290EC",
    stroke: "#3290EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 11.4599C16.0182 11.4599 13 14.4443 13 18.1342C13 23.1399 19.75 30.5292 19.75 30.5292C19.75 30.5292 26.5 23.1399 26.5 18.1342C26.5 14.4443 23.4818 11.4599 19.75 11.4599ZM19.75 20.5178C18.4193 20.5178 17.3393 19.45 17.3393 18.1342C17.3393 16.8184 18.4193 15.7505 19.75 15.7505C21.0807 15.7505 22.1607 16.8184 22.1607 18.1342C22.1607 19.45 21.0807 20.5178 19.75 20.5178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.9505c9bd62fba3fa68b1f88bd91f8d62.svg";
export { ForwardRef as ReactComponent };